import React from 'react';
import { Link } from 'react-router-dom'
import { Footer } from '../Common/Footer';
import ProductsUpload from '../../Models/ProductsUpload';
import { connect } from 'react-redux';
import { productUpload } from '../../Action/productUpload';
import { withRouter } from 'react-router';
import CKEditor from 'ckeditor4-react';
import SimpleReactValidator from 'simple-react-validator';
import { Header } from '../Common';
import axios from 'axios';
import Resizer from 'react-image-file-resizer';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import ImageUploader from 'react-images-upload';
class ProductUpload extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        this.state = {

            services: [
                {
                    id: 0,
                    serviceName: '',
                    price: '',
                }
            ],
            pictures: [],


            files: [],
            modal: false,
            _id: 1,
            firstTitle: '',
            id: '',
            secondTitle: '',
            description: '',
            servicePrice: '',
            autoPayment: '',
            expectedDelivary: '',
            delivaryFormat: '',
            numberOfOrders: '',
            acceptance: '',
            paidForService: '',
            affiliatorPromote: '',
            categories: [],
            subCategories: [],
            affiliatorCommission: [],
            subCategory: 259,
            Category: 258,
            affCommission: '',
            includeTransaction: '',
            includeVat: true,
            selectedFile: null,
            picture: '',
            file1: '',
            file2: '',
            file3: '',
            file4: '',
            file5: '',
            editor_msg: '',
            message: '',
            flag: '',
            IsDraft: '',
            singlePictureString: '',
            counter: 0,
            selfaff: '',
            selectedOption: 1,
        };
        // this.state.files[0]='';
        this.getCategories();
        this.getAffiliatorCommission();
        // this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            locale: 'klingon',
        })
    }
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    onEditorChange(evt) {
        this.setState({
            editor_msg: evt.editor.getData()
        });
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }

    handleChange(e) {
        this.setState({
            Category: this.refs.Category.value
        })
        ProductsUpload.getSubCategory(e.target.value).then(res => {
            this.setState({
                subCategories: res.data.category_sub
            })
        })
    }

    handleChangesubcat(e) {
        this.setState({
            subCategory: this.refs.subCategory.value
        })
    }

    handleOptionChange(e) {
        console.log(this.state.selectedOption)
        this.setState({
            selectedOption: e.target.value
        });
    }

    checkValue(a) {
        this.validator.showMessageFor(a)
        let data = {
            'name': this.state.firstTitle
        }
        ProductsUpload.getTitle(data).then(res => {
            if (res.data.flag === 1) {
                alert('このタイトルは、既に登録されています')
                this.state.firstTitle = ''
            } else {
                this.state.firstTitle = this.state.firstTitle
            }
        })
    }

    getCategories() {
        ProductsUpload.getCategoryDropdown().then(res => {
            this.setState({ categories: res.data.categories })
        })
    }

    updateChange(e) {
        this.setState({
            delivaryFormat: e.target.value,
        })
    }
    updateAffChange(e) {
        this.setState({
            affCommission: e.target.value,
        })
    }

    updateChange1(e) {
        this.setState({
            acceptance: e.target.value
        })
    }

    handleIsDraft() {
        console.log('drft', this.state.IsDraft)
        this.setState({ IsDraft: 0 })
    }

    handlePublish() {
        this.setState({ IsDraft: 1 })
    }

    getAffiliatorCommission() {
        ProductsUpload.getCategory().then(res => {
            this.setState({ affiliatorCommission: res.data.aff_points })
        })
    }

    onChange(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        if (file != '' || file != undefined || file != null) {
            let filesize = e.target.files[0].size / 1024 / 1024;
            console.log(filesize);
            if (filesize <= 3) {
                reader.onloadend = () => {
                    this.setState({
                        file: file,
                        imagePreviewUrl: reader.result
                    })

                }
                reader.readAsDataURL(file)
            } else {
                this.setState({
                    file: '',
                })
                alert('画像は 20KB～3MB 以内にして下さい')

            }
        }
    }

    onChange5(e) {
        let reader = new FileReader();
        let file = e.target.files[0];
        var pictures = this.state.pictures;
        let fileSize = e.target.files[0].size / 1024 / 1024;
        var counter = this.state.counter;
        reader.onloadend = () => {
            if (fileSize <= 3) {
                pictures.push({      //multiple Image
                    id: pictures.length,
                    file: file,
                    imagePreviewUrl: reader.result
                });
            }else{
                alert('画像は 20KB～3MB 以内にして下さい')
            }
            this.setState({
                pictures,
                counter: this.state.counter + 1,
            })       //multiple image
        }
        reader.readAsDataURL(file)

    }

    toggle() {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    // addMore() {
    //     this.setState(preState =>
    //         ({
    //             services: [...preState.services, {
    //                 id:0,
    //                 serviceName: '',
    //                 price: ''
    //             }]
    //         })
    //     );
    // }

    // createUI() {
    //     return this.state.services.map((el, i) => (
    //         <div key={i} className="mt-2">
    //             <input placeholder="" name="serviceName" className="basic_input" value={el.serviceName || ''} onChange={this.handleChange.bind(this, i)} />
    //             <input type="number" placeholder="" name="price" className="basic_input ml-2" style={{ width: '10%' }} value={el.price || ''} onChange={this.handleChange.bind(this, i)} /> 円
    //             <button className="btn btn-sm btn-danger ml-2" onClick={this.removeClick.bind(this, i)} >remove</button>
    //         </div>
    //     ))
    // }

    // handleChange(i, e) {
    //     const { name, value } = e.target;
    //     let services = [...this.state.services];
    //     services[i] = { ...services[i], [name]: value };
    //     this.setState({ services });
    // }

    // removeClick(i) {
    //     let services = [...this.state.services];
    //     services.splice(i, 1);
    //     this.setState({ services });
    // }

    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            console.log('eeee')
            var logged_user = JSON.parse(window.localStorage.getItem('info'));
            if (this.state.id === 'undefined' || this.state.id === '' || this.state.id === null) {
                this.setState({ id: '' })
            }
            if (this.state.singleImage) {
                if (this.state.singleImage === undefined || this.state.singleImage === '' || this.state.singleImage === null) {
                    this.state.singlePictureString = '';
                }
                else {
                    this.state.singlePictureString = this.state.singleImage;
                }
            }
            if (this.state.picture === 'undefined' || this.state.picture === '' || this.state.picture === null) {
                this.setState({ picture: '' })
            }
            let pre = this.state.editor_msg;
            let exp = /(\b(((https?|ftp|file|):\/\/)|www[.])[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig;
            let refine = pre.replace(exp, '');
            let cleanText = refine.replace(/<\/?[^>]+(>|$)/g, "");
            this.setState({
                editor_msg: pre
            });
            if (this.state.IsDraft === 0) {
                const formData = new FormData();
                formData.append('id', this.state.id)
                formData.append('title', this.state.firstTitle)
                formData.append('single_picture', this.state.file)
                formData.append('single_picture_string', this.state.singlePictureString)
                this.state.pictures.map((file) => {
                    console.log(file);
                    formData.append('file[]', file.file);
                    formData.append('file_string[]', file.image);
                });

                // formData.append('file', this.state.pictures)  //multiple Image
                // formData.append('services', JSON.stringify(this.state.services))
                formData.append('short_desc', this.state.secondTitle)
                formData.append('seller_id', logged_user.id)
                formData.append('price_int', this.state.servicePrice)
                formData.append('expected_delivery_days', this.state.expectedDelivary)
                formData.append('delivery_format', this.state.delivaryFormat)
                formData.append('no_of_order_at_atime', this.state.numberOfOrders)
                formData.append('sub_category_id', this.refs.subCategory.value)
                formData.append('category_id', this.refs.Category.value)
                formData.append('affiliator_commission', this.refs.affCommission.value)
                formData.append('commission_in_ex_vat', this.state.includeVat)
                formData.append('commission_in_ex_vat', this.state.includeVat)
                // formData.append('paidForService', this.state.paidForService)
                // formData.append('is_to_be_affiliated', this.state.affiliatorPromote)
                formData.append('long_desc', this.state.editor_msg)
                formData.append('is_estimate_or_customizable', this.state.acceptance)
                formData.append('is_draft', this.state.IsDraft)
                formData.append('selfaff', this.state.selfaff)
                formData.append('autoPayment', this.state.autoPayment)
                axios({
                    method: 'post',
                    url: 'http://127.0.0.1/sharework_back_v2/public/backend/upload-product',
                    // url: 'https://share-work.jp/backend/upload-product',
                    data: formData,
                    config: {
                        headers: {
                            'content-type': 'multipart/form-data'
                        }
                    }
                }).then(res => {
                    console.log(res.data.status)
                    if (res.data.status === 200) {
                        alert('正常に保存されました')
                        window.location.href = '/service-list';
                    }
                })
                    .catch(
                        console.log('asd')
                    )
            } else {
                this.props.history.push({
                    pathname: `/product-upload-confirm`,
                    state: {
                        firstTitle: this.state.firstTitle,
                        singlePicture: this.state.file,
                        picture: this.state.pictures, //multiple Image
                        secondTitle: this.state.secondTitle,
                        seller_id: logged_user.id,
                        servicePrice: this.state.servicePrice,
                        expectedDelivary: this.state.expectedDelivary,
                        delivaryFormat: this.state.delivaryFormat,
                        numberOfOrders: this.state.numberOfOrders,
                        // subCategory: this.refs.subCategory.value,
                        // Category: this.refs.Category.value,
                        subCategory: this.state.subCategory,
                        Category: this.state.Category,
                        affCommission: this.refs.affCommission.value,
                        includeVat: this.state.includeVat,
                        paidForService: this.state.paidForService,
                        affiliatorPromote: this.state.affiliatorPromote,
                        editor_msg: this.state.editor_msg,
                        IsDraft: this.state.IsDraft,
                        acceptance: this.state.acceptance,
                        selfaff: this.state.selfaff,
                        autoPayment: this.state.autoPayment,
                    }
                })
            }
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }
    //multiple Image
    deleteImage(i) {
        let pictures = this.state.pictures;
        const removeIndex = pictures.findIndex(e => e.id === i);
        const filteredPictures = this.state.pictures.filter((e, index) => index !== removeIndex);
        this.setState({ pictures: filteredPictures, counter: this.state.counter - 1 })
    }

    imagePreview(x, id, i) {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 1200;
        if (isMobile) {
            if (i < 3) {
                return (
                    <div>
                        <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                            <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                            </div>
                            <img src={x} />
                        </div>
                    </div>
                )
            } else if (i >= 3 && i <= 5) {
                return (
                    <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                        <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                            <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                        </div>
                        <img src={x} />
                    </div>
                )
            } else if (i >= 6 && i <= 8) {
                return (
                    <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                        <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                            <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                        </div>
                        <img src={x} />
                    </div>
                )
            } else if (i >= 9 && i <= 10) {
                return (
                    <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                        <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                            <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                        </div>
                        <img src={x} />
                    </div>
                )
            }
        } else if (isDesktop) {
            if (i < 5) {
                return (
                    <div>
                        <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '0px' }}>
                            <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                                <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                            </div>
                            <img src={x} />
                        </div>
                    </div>
                )
            } else if (i >= 5 && i <= 10) {
                return (
                    <div className="imgPreview" style={{ position: 'relative', marginRight: '5px', marginTop: '10px' }}>
                        <div className="btn" onClick={this.deleteImage.bind(this, id)}>
                            <span onClick={this.deleteImage.bind(this, id)} style={{ fontSize: '15px', color: 'red' }}>x</span>
                        </div>
                        <img src={x} />
                    </div>
                )
            }
        }
    }

    image() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="catagory_select" style={{ width: "65%", marginLeft: '0px', }} onChange={this.onChange5.bind(this)} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        } else if (isDesktop) {
            if (this.state.counter < 10) {
                return (
                    <input type="file" className="" onChange={this.onChange5.bind(this)} />
                )
            } else {
                return (
                    <div></div>
                )
            }
        }
    }

    title() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <input type="text" className="basic_input catch_copy_input p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('タイトル', this.state.firstTitle, 'required|min:10|max:25')}</span>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div>
                    <input type="text" className="basic_input input_width_height1 p-2" value={this.state.firstTitle} onChange={this.updateValue.bind(this, 'firstTitle')} onBlur={this.checkValue.bind(this, 'firstTitle')} /><br />
                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('タイトル', this.state.firstTitle, 'required|min:10|max:25')}</span>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        let { imagePreviewUrl } = this.state;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="input_name big_font guide_text" >
                            サービスの出品
                        </div>
                        <form onSubmit={this.handleSubmit.bind(this)}>
                            <div className="row form-group">
                                <div className="col-md-1"></div>
                                <div className="col-md-10">
                                    <div className="">
                                        <div className=" ">
                                            <h2>{this.state.message}</h2>
                                        </div>
                                        <div className="" style={{ display: "none" }}>
                                            <div className="field_text_width">
                                                <span className="common_text_bold">カテゴリー</span><br />
                                                <span className="mandatory_alert font_12" >* 必須</span>
                                            </div>
                                            <div className="field_width">
                                                <select className="cat_drop catagory_select" ref="Category" onChange={this.handleChange.bind(this)} >
                                                    <option value=""> 選択してください</option>
                                                    {this.state.categories.map(rp =>
                                                        <option value={rp.id} key={rp.id} name={rp.cat_name}>
                                                            {rp.cat_name}
                                                        </option>
                                                    )}
                                                </select>
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message('カテゴリー', this.state.Category, 'required')}
                                                </span>
                                                <select className="cat_drop catagory_select ml-2" ref="subCategory" onChange={this.handleChangesubcat.bind(this)} >
                                                    <option value=""> 選択してください</option>
                                                    {this.state.subCategories.map(rp =>
                                                        <option value={rp.id} key={rp.id}>
                                                            {rp.cat_name}
                                                        </option>
                                                    )}
                                                </select>
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}
                                                </span>
                                            </div>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>
                                            <span className="common_text_bold">サービスタイトル</span><br />
                                            <span className="mandatory_alert font_12">* 必須 </span> <span className="font_12">(10~25字以内)</span><br />
                                        </div>
                                        <div className="">
                                            {this.title()}
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>
                                            <span className="common_text_bold">キャッチコピー</span><br />
                                            <span className="mandatory_alert font_12">* 必須</span> <span className="font_12">(15~30字以内)</span><br />
                                        </div>
                                        <div className="">
                                            <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('キャッチコピー', this.state.secondTitle, 'required|min:15|max:30')}</span>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div className="field_text_width" style={{ width: "100%" }}>
                                            <span className="common_text_bold">サービス内容</span><br />
                                            <span className="mandatory_alert font_12">* 必須</span> <span className="font_12">(1~5000字以内)</span>
                                        </div>
                                        <div className="field_width">
                                            <CKEditor
                                                data={this.state.editor_msg}
                                                onChange={this.onEditorChange.bind(this)}
                                                onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                config={{
                                                    removePlugins: [['link']]
                                                }}
                                            />
                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('サービス内容', this.state.editor_msg, 'required|min:1|max:5000')}</span>
                                        </div>
                                    </div>
                                    <div className="" style={{ paddingLeft: '4%' }}>
                                        <div>
                                            <div>
                                                <div>&nbsp;</div>
                                                <div className="">
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">トップに表示したい画像 </span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span><br />
                                                        <span className="mandatory_alert font_12">* 画像は 20KB～3MB 以内にして下さい</span><br />
                                                        <span className="mandatory_alert font_12">* 画像形式は JPEG, JPG, PNG, GIF 可能</span><br />
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width" style={{ height: '104px' }}>
                                                        <div style={{ width: '65%' }}><input type="file" className="catagory_select" onChange={this.onChange.bind(this)} /></div>
                                                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('トップに表示したい画像', this.state.file, 'required')}</span>
                                                        <div className="imgPreview" style={{ border: '0px' }} >
                                                            <img src={imagePreviewUrl} />
                                                        </div>

                                                        {/* {this.image()}
                                                            <div className="row" style={{ marginLeft: '0px', width: '450px', marginTop: '20px', marginRight: '5px' }}>
                                                                <div className="imgPreview" style={{ marginTop: '0px' }}>
                                                                    <div className="row" style={{ marginLeft: '0px', width: '450px', marginRight: '5px' }}>
                                                                        {this.state.pictures.map((p, i) => this.imagePreview(p.imagePreviewUrl, p.id, i)
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div> */}
                                                    </div>
                                                    {/* <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('トップに表示したい画像', this.state.singlePicture, 'required')}</span> */}

                                                </div>
                                                <div className="">
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">画像 </span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span><br />
                                                        <span className="mandatory_alert font_12">* 画像は 20KB～3MB 以内にして下さい</span><br />
                                                        <span className="mandatory_alert font_12">* 画像形式は JPEG, JPG, PNG, GIF 可能</span><br />
                                                        <span className="mandatory_alert font_12">* 最大10個まで画像をアップ可能です</span><br />
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width " style={{ height: 'auto' }}>
                                                        {this.image()}
                                                        <div className="row " style={{ marginLeft: '0px', width: '280px', marginTop: '20px', marginRight: '5px' }}>
                                                            <div className="" style={{ marginTop: '0px' }}>
                                                                <div className="row" style={{ marginLeft: '0px', width: '280px', marginRight: '5px' }}>
                                                                    {this.state.pictures.map((p, i) => this.imagePreview(p.imagePreviewUrl, p.id, i)
                                                                    )}
                                                                </div>
                                                            </div>
                                                            {/* <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="imgPreview" style={{ marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="imgPreview" style={{ marginLeft: '5px', marginTop: '10px' }}></div>  */}
                                                        </div>
                                                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('画像', this.state.pictures, 'required')}</span>
                                                    </div>
                                                    <div>&nbsp;</div>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">サービス価格</span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '39px' }}>
                                                            <div className="" style={{ height: '39px' }}>
                                                                <input type="text" className="basic_input input_width_height2 p-2" style={{ width: "100%" }} value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input> &nbsp;
                                                            </div>
                                                            &nbsp;<span className="my-auto">円</span>&nbsp;&nbsp;

                                                            <div style={{ marginTop: '14px' }}>
                                                                <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                            </div>
                                                            <div class="my-auto">
                                                                継続課金
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <span className="field_width">(20%の取引手数料を含む)</span>
                                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('サービス価格', this.state.servicePrice, 'required|integer')}</span>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">アフィリエイト報酬</span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <div className="row" style={{ marginLeft: '0px', marginRight: '0px', height: '30px' }}>
                                                            <div className="" style={{ height: '30px' }}>
                                                                <select className="cat_drop mr-1 catagory_select" style={{ width: "100%" }}  onChange={this.updateAffChange.bind(this)} value={this.state.affCommission}ref="affCommission" onBlur={() => this.validator.showMessageFor('affCommission')}>
                                                                    <option value="">選択してください </option>
                                                                    {this.state.affiliatorCommission.map(rp =>
                                                                        <option value={rp.id} key={rp.id}>
                                                                            {rp.point_value}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                            </div>
                                                            &nbsp;&nbsp;
                                                            <span className="my-auto">%</span>

                                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                                            <div style={{ marginTop: '9px' }}>
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                            </div>
                                                            <div class="my-auto">
                                                                自己購入可能
                                                            </div>

                                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('アフィリエイト報酬', this.state.affCommission, 'required')}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">提供形式</span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <select className="cat_drop catagory_select" onChange={this.updateChange.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                            <option value="">選択してください</option>
                                                            <option value="video">動画</option>
                                                            <option value="pdf">PDF</option>
                                                            <option value="audio">音声</option>
                                                            <option value="chat">チャット</option>
                                                        </select>
                                                        <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('提供形式', this.state.delivaryFormat, 'required')}</span>
                                                    </div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold">予想お届け日数</span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <input type="text" className="basic_input input_width_height2 p-2" style={{ width: "33%" }} value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> 日
                                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('予想お届け日数', this.state.expectedDelivary, 'required|integer')}</span>
                                                    </div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold"> 受注可能な件数  </span><br />
                                                        <span className="mandatory_alert font_12">* 必須</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <input type="text" className="basic_input input_width_height2 p-2" style={{ width: "33%" }} value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;件&nbsp;
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('受注可能な件数', this.state.numberOfOrders, 'required|integer')}</span>
                                                    </div>
                                                </div>

                                                {/* <div>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">有料オプション</span><br />
                                                            </div>
                                                            <td className="width_5"></div>
                                                            <div>{this.createUI()}
                                                                <div>
                                                                    <button className="btn btn-sm btn-info mt-2" onClick={this.addMore.bind(this)}>add more</button>
                                                                </div>
                                                            </div>
                                                        </div> */}

                                                <div><div>&nbsp;</div></div>

                                                <div>
                                                    <div className="field_text_width" style={{ width: '100%' }}>
                                                        <span className="common_text_bold"> 見積り・カスタマイズの受付</span>
                                                    </div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <select className="cat_drop catagory_select" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} onBlur={() => this.validator.showMessageFor('acceptance')}>
                                                            <option value="">選択してください </option>
                                                            <option value="YES">受け付ける </option>
                                                            <option value="NO">受け付けしない </option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div><div>&nbsp;</div></div>
                                                {/* <div>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">Paid for Service</span>
                                                            </div>
                                                            <td className="width_5"></div>
                                                            <td className="field_width">
                                                                <input type="checkbox" name="" value={this.state.paidForService} onChange={this.updateValue.bind(this, 'paidForService')} />  paid for service  <br />
                                                            </div>
                                                        </div> */}
                                                <div><div>&nbsp;</div></div>

                                                <div><div>&nbsp;</div></div>
                                                <div>
                                                    <div></div>
                                                    <div className="width_5"></div>
                                                    <div className="field_width">
                                                        <span className="mr-0">
                                                            <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons " style={{ width: '125px' }}>下書きで保存</button>
                                                        </span>
                                                        <span className="ml-0">
                                                            <button type="submit"
                                                                onClick={this.handlePublish.bind(this)}
                                                                className="btn  product_upload_buttons"
                                                                style={{ width: '125px', marginLeft: '9px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>
                                                                確認する
                                                                </button>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div>
                                                    <div colSpan="3">&nbsp;</div>
                                                </div>
                                                {/* <div>
                                                            <div></div>
                                                            <td colSpan="2" >
                                                                <span className="blue_text ml-5"><u>Delete Draft</u></span>
                                                            </div>
                                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div>&nbsp;</div>
                                </div>
                                <div className="col-md-1"></div>
                            </div>
                        </form>
                    </div>
                    <Footer />
                </div >
            );
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className=" input_name big_font guide_text" style={{ marginLeft: '130px' }}>
                                    サービスの出品
                            </div>
                                <form onSubmit={this.handleSubmit.bind(this)}>
                                    <div className="row form-group">
                                        <div className="col-md-1"></div>
                                        <div className="col-md-10">
                                            <div className="childs pt-0">
                                                <div className=" ">
                                                    <h2>{this.state.message}</h2>
                                                </div>
                                                <div className="" style={{ display: "none" }}>
                                                    <div className="field_text_width">
                                                        <span className="common_text_bold">カテゴリー</span><br />
                                                        <span className="mandatory_alert font_12" >* 必須</span>
                                                    </div>
                                                    <div className="field_width">
                                                        <select className="cat_drop" ref="Category" onChange={this.handleChange.bind(this)} >
                                                            <option value=""> 選択してください</option>
                                                            {this.state.categories.map(rp =>
                                                                <option value={rp.id} key={rp.id} name={rp.cat_name}>
                                                                    {rp.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('カテゴリー', this.state.Category, 'required')}
                                                        </span>
                                                        <select className="cat_drop ml-2" ref="subCategory" onChange={this.handleChangesubcat.bind(this)} >
                                                            <option value=""> 選択してください</option>
                                                            {this.state.subCategories.map(rp =>
                                                                <option value={rp.id} key={rp.id}>
                                                                    {rp.cat_name}
                                                                </option>
                                                            )}
                                                        </select>
                                                        <span style={{ color: "red", fontSize: "12px" }}>
                                                            {this.validator.message('サブカテゴリー', this.state.subCategory, 'required')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span className="common_text_bold">サービスタイトル</span><br />
                                                    <span className="mandatory_alert font_12">* 必須 </span> <span className="font_12">(10~25字以内)</span><br />
                                                </div>
                                                <div className="">
                                                    {this.title()}
                                                </div>
                                                <div>&nbsp;</div>
                                                <div>
                                                    <span className="common_text_bold">キャッチコピー</span><br />
                                                    <span className="mandatory_alert font_12">* 必須</span> <span className="font_12">(15~30字以内)</span><br />
                                                </div>
                                                <div className="">
                                                    <input type="text" className="catch_copy_input p-2" value={this.state.secondTitle} onChange={this.updateValue.bind(this, 'secondTitle')} onBlur={() => this.validator.showMessageFor('secondTitle')} /><br />
                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('キャッチコピー', this.state.secondTitle, 'required|min:15|max:30')}</span>
                                                </div>
                                                <div>&nbsp;</div>
                                                <div className="field_text_width">
                                                    <span className="common_text_bold">サービス内容</span><br />
                                                    <span className="mandatory_alert font_12">* 必須</span> <span className="font_12">(1~5000字以内)</span>
                                                </div>
                                                <div className="field_width">
                                                    <CKEditor
                                                        data={this.state.editor_msg}
                                                        onChange={this.onEditorChange.bind(this)}
                                                        onBlur={() => this.validator.showMessageFor('editor_msg')}
                                                        config={{
                                                            removePlugins: [['link']]
                                                        }}
                                                    />
                                                    <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('サービス内容', this.state.editor_msg, 'required|min:1|max:5000')}</span>
                                                </div>
                                            </div>
                                            <div className="" style={{ paddingLeft: '4%' }}>
                                                <table>
                                                    <tbody>
                                                        <div>&nbsp;</div>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">トップに表示したい画像 </span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span><br />
                                                                <span className="mandatory_alert font_12">* 画像は 20KB～3MB 以内にして下さい</span><br />
                                                                <span className="mandatory_alert font_12">* 画像形式は JPEG, JPG, PNG, GIF 可能</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                <input type="file" className="" onChange={this.onChange.bind(this)} />
                                                                <div className="imgPreview" style={{ border: '0px' }}>
                                                                    <img src={imagePreviewUrl} />
                                                                </div>
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('トップに表示したい画像', this.state.file, 'required')}</span>
                                                            </td> <div>&nbsp;</div>
                                                        </tr>
                                                        <div>&nbsp;</div>
                                                        <tr className="">
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">画像 </span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span><br />
                                                                <span className="mandatory_alert font_12">* 画像は 20KB～3MB 以内にして下さい</span><br />
                                                                <span className="mandatory_alert font_12">* 画像形式は JPEG, JPG, PNG, GIF 可能</span><br />
                                                                <span className="mandatory_alert font_12">* 最大10個まで画像をアップ可能です</span><br />
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ height: '104px' }}>
                                                                {this.image()}
                                                                <div className="row col-md-12 pl-0 " style={{ marginLeft: '0px', marginTop: '20px', marginRight: '5px' }}>
                                                                    <div className="" style={{ marginTop: '0px' }}>
                                                                        <div className="row multiple_image_upload" style={{ marginLeft: '0px', width: '450px!important', marginRight: '5px' }}>
                                                                            {this.state.pictures.map((p, i) => this.imagePreview(p.imagePreviewUrl, p.id, i)
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '0px' }}></div>
                                                                    <div className="" style={{ marginTop: '10px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                    <div className="" style={{ marginLeft: '5px', marginTop: '10px' }}></div>
                                                                </div>
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('画像', this.state.pictures, 'required')}</span>
                                                            </td>
                                                            <div>&nbsp;</div>
                                                        </tr>
                                                        <div>&nbsp;</div>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">サービス価格</span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ verticalAlign: 'middle' }}>
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.servicePrice} onChange={this.updateValue.bind(this, 'servicePrice')} onBlur={() => this.validator.showMessageFor('servicePrice')}></input> &nbsp;
                                                             &nbsp;<span>円  (20%の取引手数料を含む)</span>
                                                                &nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input type="checkbox" checked={this.state.autoPayment} onChange={this.updateValue.bind(this, 'autoPayment')} />&nbsp;&nbsp;
                                                                    継続課金
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('サービス価格', this.state.servicePrice, 'required|integer')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr style={{ height: '39px' }}>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">アフィリエイト報酬</span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width" style={{ verticalAlign: 'middle' }}>
                                                                <select className="cat_drop mr-1 " ref="affCommission"  onChange={this.updateAffChange.bind(this)} value={this.state.affCommission} onBlur={() => this.validator.showMessageFor('affCommission')}>
                                                                    <option value="">選択してください </option>
                                                                    {this.state.affiliatorCommission.map(rp =>
                                                                        <option value={rp.id} key={rp.id}>
                                                                            {rp.point_value}
                                                                        </option>
                                                                    )}
                                                                </select>
                                                                %
                                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                <input type="checkbox" checked={this.state.selfaff} onChange={this.updateValue.bind(this, 'selfaff')} />&nbsp;&nbsp;
                                                                    自己購入可能
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('アフィリエイト報酬', this.state.affCommission, 'required')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">提供形式</span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop" onChange={this.updateChange.bind(this)} value={this.state.delivaryFormat} onBlur={() => this.validator.showMessageFor('delivaryFormat')}>
                                                                    <option value="">選択してください</option>
                                                                    <option value="video">動画</option>
                                                                    <option value="pdf">PDF</option>
                                                                    <option value="audio">音声</option>
                                                                    <option value="chat">チャット</option>
                                                                </select>
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('提供形式', this.state.delivaryFormat, 'required')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold">予想お届け日数</span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.expectedDelivary} onChange={this.updateValue.bind(this, 'expectedDelivary')} onBlur={() => this.validator.showMessageFor('expectedDelivary')} /> 日
                                                            <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('予想お届け日数', this.state.expectedDelivary, 'required|integer')}</span>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold"> 受注可能な件数  </span><br />
                                                                <span className="mandatory_alert font_12">* 必須</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <input type="text" className="basic_input input_width_height2 p-2" value={this.state.numberOfOrders} onChange={this.updateValue.bind(this, 'numberOfOrders')} onBlur={() => this.validator.showMessageFor('numberOfOrders')} />&nbsp;件&nbsp;
                                                                <span style={{ color: "red", fontSize: '12px' }}>{this.validator.message('受注可能な件数', this.state.numberOfOrders, 'required|integer')}</span>
                                                            </td>
                                                        </tr>


                                                        <tr><td>&nbsp;</td></tr>

                                                        <tr>
                                                            <td className="field_text_width">
                                                                <span className="common_text_bold"> 見積り・カスタマイズの受付</span>
                                                            </td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <select className="cat_drop" onChange={this.updateChange1.bind(this)} value={this.state.acceptance} onBlur={() => this.validator.showMessageFor('acceptance')}>
                                                                    <option value="">選択してください </option>
                                                                    <option value="YES">受け付ける </option>
                                                                    <option value="NO">受け付けしない </option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <tr><td>&nbsp;</td></tr>

                                                        <tr><td>&nbsp;</td></tr>

                                                        <tr><td>&nbsp;</td></tr>
                                                        <tr>
                                                            <td></td>
                                                            <td className="width_5"></td>
                                                            <td className="field_width">
                                                                <span className="mr-3">
                                                                    <button type="submit" onClick={this.handleIsDraft.bind(this)} className="btn btn-secondary product_upload_buttons " style={{ width: '125px' }}>下書きで保存</button>
                                                                </span>
                                                                <span className="ml-5">
                                                                    <button type="submit"
                                                                        onClick={this.handlePublish.bind(this)}
                                                                        className="btn  product_upload_buttons"
                                                                        style={{ width: '125px', backgroundColor: "#7ea9e6", borderColor: "#6290d1", color: '#fff', boxShadow: "#ffffff4d 0px 1px 0px 0px inset" }}>
                                                                        確認する
                                                                </button>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan="3">&nbsp;</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div>&nbsp;</div>
                                        </div>
                                        <div className="col-md-1"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            );
        }
    }
}
const mapStateToProps = (state) => ({
    productUpload: state.productUpload,
    errors: state.errors,
    // categories: state.categories,
});

ProductUpload = connect(mapStateToProps, { productUpload })(withRouter(ProductUpload));

export { ProductUpload }